import React from 'react';

type AuthMethod = 'telegram' | 'email' | '';

interface OtpMethodProps {
  isLoading: boolean;
  method: AuthMethod;
  onSelect: (method: AuthMethod) => void;
  onBack: () => void;
  errorOnSend: string
}

const OTP_METHODS: { label: string; value: AuthMethod }[] = [
  { label: 'Telegram', value: 'telegram' },
  { label: 'Email', value: 'email' },
];

const OtpSend: React.FC<OtpMethodProps> = ({ isLoading, method, onSelect, onBack, errorOnSend }) => (
  <div className="nexus-content">
    <h2>Verification Code</h2>
    <p className="nexus-subtitle">Choose how to receive your code</p>
    <div className="nexus-error-container verification-error">
      {errorOnSend && <span className="nexus-error-message">{errorOnSend}</span>}
    </div>
    {OTP_METHODS.map(({ label, value }) => (
      <button
        key={value}
        className={`nexus-btn ${method === value && isLoading ? 'loading' : ''}`}
        disabled={isLoading}
        onClick={() => onSelect(value)}
      >
        {isLoading && method === value ? 'Sending...' : label}
      </button>
    ))}

    <button className="nexus-btn-back" onClick={onBack} disabled={isLoading}>
      ← Change Email
    </button>
  </div>
);

export default OtpSend;
